<mat-form-field class="select-input-wrapper">
  <mat-label>
    {{ label | translate }}
  </mat-label>

  <!--suppress HtmlFormInputWithoutLabel -->
  <input
    matInput
    type="text"
    [formControl]="searchableSelectControl"
    [matAutocomplete]="searchableSelect"
    [placeholder]="placeholder | translate"
    autocomplete="off"
  />

  <mat-hint>
    {{ getSelectedOptionNames() || ('TRANS__ADVANCED_SEARCH__SEARCH_DROPDOWN_HINT' | translate) }}
  </mat-hint>

  @if (loading) {
    <mat-progress-spinner
      matSuffix
      mode="indeterminate"
      color="accent"
      [diameter]="15"
      [strokeWidth]="3"
    ></mat-progress-spinner>
  }

  <!--  FIXME: Proper styling and event handling when mode is multiselect-->
  <mat-autocomplete
    #searchableSelect="matAutocomplete"
    [displayWith]="displayWith"
  >
    @if (availableOptionCount === 0) {
      <mat-option disabled>
        {{ 'TRANS__ADVANCED_SEARCH__SEARCH_DROPDOWN__NO_OPTIONS_AVAILABLE' | translate }}
      </mat-option>
    }

    @for (opt of options$ | async; track $index) {
      <mat-option
        [value]="opt"
        (onSelectionChange)="setSearchValue($event)"
      >
        @if (multiple) {
          <mat-checkbox [checked]="isSelected(opt)"></mat-checkbox>
        }

        {{ displayWith(opt) }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
